export default "__VITE_ASSET__2d4f5973__"